"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2920],{

/***/ 62920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66261);


var Video = function(param) {
    var intro = param.intro, heading = param.heading, title1 = param.title1, title2 = param.title2, title3 = param.title3, movie = param.movie, body = param.body, placeholder = param.placeholder, button = param.button, fontsize1 = param.fontsize1, fontsize2 = param.fontsize2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "video-hero wrapper angled lower-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "mt-10 animate__animated animate__slideInUp animate__delay-1s",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                className: "mt-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "hero_text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "fs-".concat(fontsize1),
                                style: {
                                    fontFamily: "avenir !important"
                                },
                                children: title1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "fs-".concat(fontsize2),
                                style: {
                                    fontFamily: "avenir !important"
                                },
                                children: title2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        autoPlay: true,
                        loop: true,
                        playsInline: true,
                        muted: true,
                        poster: placeholder,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: movie,
                            type: "video/mp4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-12 col-sm-12 col-lg-11 col-xl-10 mx-auto text-center mb-5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "animate__animated animate__slideInUp animate__delay-2s",
                            children: [
                                "SEOptimist  ",
                                intro
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_scroll__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                            to: "ai-seo",
                            spy: true,
                            smooth: true,
                            offset: 0,
                            duration: 500,
                            className: "mt-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "animate__animated animate__slideInUp animate__delay-3s",
                                    children: "Learn more"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "animate__animated animate__slideInUp animate__delay-4s",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        style: {
                                            lineHeight: 0.75
                                        },
                                        className: "text-primary uil uil-angle-double-down fs-40"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Video);


/***/ })

}]);